import React, { useState, useEffect } from "react";
import { authService } from "../api/authService";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../contexts/NotificationContext";
import bgLeft from "../assets/img/bg_left.png";
import logoPrimary from "../assets/img/Logo ASAlink Primary.png";
import logoSecondary from "../assets/img/Logo ASAlink Secondary.png";

export default function Login() {
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Check if user is already logged in
  useEffect(() => {
    if (authService.isAuthenticated()) {
      const userData = authService.getCurrentUser();
      console.log("Already authenticated, checking admin status...", userData);
      console.log("isAdmin():", authService.isAdmin());

      if (authService.isSystemAdmin()) {
        console.log("System admin authenticated, redirecting to admin panel");
        window.location.replace(window.location.origin + "/admin");
      } else {
        console.log("User authenticated, redirecting to home");
        window.location.replace(window.location.origin + "/");
      }
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const payload = { email, password };
      console.log("Attempting login...", payload);

      const response = await authService.login(payload);
      console.log("Login response:", response);

      // Check if login was successful
      if (!response?.data) {
        throw new Error("Invalid response from server");
      }

      showSuccess("Login berhasil");

      // Wait for authentication to be properly set
      let attempts = 0;
      const maxAttempts = 10;

      while (attempts < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        if (authService.isAuthenticated()) {
          console.log(
            "Authentication confirmed after",
            attempts + 1,
            "attempts",
          );
          break;
        }
        attempts++;
      }

      if (!authService.isAuthenticated()) {
        throw new Error("Authentication failed - data not stored properly");
      }

      // Redirect based on user role
      const userData = authService.getCurrentUser();
      const isSystemAdmin = authService.isSystemAdmin();
      console.log("Final user data:", userData);
      console.log("Is system admin check:", isSystemAdmin);

      if (isSystemAdmin) {
        console.log("Redirecting to admin panel...");
        window.location.replace(window.location.origin + "/admin");
      } else {
        console.log("Redirecting to home...");
        window.location.replace(window.location.origin + "/");
      }
    } catch (err) {
      console.error("Login error:", err);
      const errMsg =
        err.response?.data?.message || err.message || "Login gagal";
      setError(errMsg);
      showError(errMsg);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen md:h-screen md:overflow-hidden flex bg-slate-50 text-slate-800">
      {/* Left Brand Panel — hidden on mobile, 50% on tablet/desktop */}
      <aside 
        className="hidden md:flex md:w-1/2 relative overflow-hidden bg-cover text-white"
        style={{ backgroundImage: `url(${bgLeft})`, backgroundPosition: 'right center' }}
      >
        <div className="relative z-10 flex flex-col justify-start pt-6 lg:pt-8 p-6 lg:px-10 w-full h-full bg-slate-900/10">
          
          <div className="space-y-3 lg:space-y-4">
            {/* Logo Secondary */}
            <img src={logoSecondary} alt="Asalink Logo" className="h-10 lg:h-16 object-contain" />

            {/* Hero copy */}
            <div className="space-y-2 lg:space-y-3 max-w-sm">
              <h2 className="text-[28px] lg:text-[44px] font-medium leading-[1.15]">
                Solusi Digital <br/>
                <span className="text-teal-400">untuk Masa Depan</span> <br/>
                <span className="text-teal-400">Bisnis Anda</span>
              </h2>
              <p className="text-teal-50/90 text-xs lg:text-sm leading-relaxed w-[240px] lg:w-[300px]">
                Kelola seluruh aktivitas bisnis dengan <br/> lebih mudah melalui solusi yang dirancang <br/> mengikuti cara kerja usaha Anda.
              </p>
            </div>

            {/* Feature highlights */}
            <ul className="grid grid-cols-1 gap-2 lg:gap-3 pt-1">
              {[
                { label: "Transaksi Lebih \n Cepat dan Tertata", icon: <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></> },
                { label: "Stok Aman dan \n Terkendali", icon: <><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></> },
                { label: "Pantau Performa \n Bisnis dengan Mudah", icon: <><path d="M18 20V10M12 20V4M6 20v-6"/></> },
                { label: "Satu Sistem, \n Semua Perangkat", icon: <><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></> },
              ].map((f, i) => (
                <li key={i} className="flex items-center gap-2 lg:gap-3 text-xs lg:text-sm font-medium text-white">
                  <span className="w-8 h-8 lg:w-12 lg:h-12 rounded-lg lg:rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "#026871" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 lg:w-6 lg:h-6 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      {f.icon}
                    </svg>
                  </span>
                  <span className="whitespace-pre-line leading-snug">{f.label}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Footer note: Cocok untuk berbagai jenis usaha */}
          <div className="mt-4 lg:mt-8 w-full max-w-[500px]">
            <div className="text-[10px] lg:text-xs font-semibold text-teal-100 mb-2 lg:mb-3 tracking-wide text-center w-full">Cocok untuk berbagai jenis usaha</div>
            <div className="border border-white/20 bg-white/5 rounded-xl lg:rounded-2xl p-2 lg:p-4 flex justify-between items-center backdrop-blur-sm w-full divide-x divide-white/20">
              {[
                { label: "Minimarket\n& Retail", icon: <><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></> },
                { label: "Kafe &\nRestoran", icon: <><path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line></> },
                { label: "Toko\nFashion", icon: <><path d="M20.38 3.46L16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"></path></> },
                { label: "Apotek &\nKlinik", icon: <><rect x="2" y="6" width="20" height="14" rx="2" ry="2"></rect><path d="M8 6V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2"></path><line x1="12" y1="10" x2="12" y2="16"></line><line x1="9" y1="13" x2="15" y2="13"></line></> },
              ].map((f, i) => (
                <div key={i} className="flex flex-row items-center justify-center gap-1.5 lg:gap-3 px-1 lg:px-2 w-full">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 lg:w-6 lg:h-6 text-white flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    {f.icon}
                  </svg>
                  <span className="text-[8px] xl:text-[10px] 2xl:text-xs text-white leading-tight whitespace-pre-line font-medium text-left">{f.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </aside>

      {/* Right Form Panel */}
      <main className="flex-1 flex flex-col items-center justify-center p-4 lg:p-8 relative bg-slate-50">
        
        <div className="w-full max-w-md bg-white border border-slate-100/50 rounded-3xl shadow-xl shadow-slate-200/40 p-8 sm:p-10">
          <div className="flex flex-col items-center mb-8">
            <img src={logoPrimary} alt="Asalink Logo" className="h-14 object-contain mb-8" />
            <h1 className="text-2xl font-bold text-slate-900 tracking-tight text-center">
              Selamat Datang Kembali
            </h1>
            <p className="text-sm text-slate-500 mt-2 text-center">
              Masuk untuk melanjutkan ke dashboard kasir Anda.
            </p>
          </div>

          {error && (
            <div className="mb-6 flex items-start gap-2.5 px-4 py-3 bg-red-50 border border-red-200 text-red-700 rounded-xl text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mt-0.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider">
                Email
              </label>
              <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
                </span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-slate-50/50 border border-slate-200 rounded-xl pl-12 pr-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 focus:bg-white transition-all"
                  placeholder="user@example.com"
                  required
                  autoComplete="email"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-700 mb-2 uppercase tracking-wider">
                Password
              </label>
              <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-slate-50/50 border border-slate-200 rounded-xl pl-12 pr-12 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 focus:bg-white transition-all"
                  placeholder="••••••••"
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((s) => !s)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors"
                  tabIndex={-1}
                  aria-label={showPassword ? "Sembunyikan password" : "Tampilkan password"}
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                  )}
                </button>
              </div>
              <div className="flex justify-end mt-2">
                <a href="#" className="text-xs font-medium text-teal-600 hover:text-teal-700 transition-colors">
                  Lupa password?
                </a>
              </div>
            </div>

            <button
              type="submit"
              className="w-full mt-4 relative overflow-hidden px-4 py-3 bg-gradient-to-r from-teal-500 to-emerald-600 hover:from-teal-600 hover:to-emerald-700 text-white rounded-xl font-bold text-sm shadow-lg shadow-teal-500/25 transition-all disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              disabled={loading}
            >
              {loading ? (
                <>
                  <svg className="w-5 h-5 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"/></svg>
                  Memproses...
                </>
              ) : (
                <>
                  Masuk
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
                </>
              )}
            </button>
          </form>
        </div>

        <div className="mt-8 flex items-center gap-2 text-xs text-slate-500">
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-slate-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <polyline points="9 12 11 14 15 10" />
          </svg>
          Dengan masuk, Anda menyetujui <a href="#" className="text-teal-600 hover:underline font-medium">ketentuan layanan</a> kami.
        </div>
      </main>
    </div>
  );
}
